import { LogLevel } from '@azure/msal-browser';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import configData from './config.json';
import { generalEnums } from './utils/enums';
import { appInsights } from './services/ApplicationInsightsService';

export const getAuthority = (token) => {
  if (token) {
    return `${configData.REACT_APP_B2C_AUTHORITY}/${generalEnums.MAGICLINKPOLICY}`;
  }

  return `${configData.REACT_APP_B2C_AUTHORITY}/${generalEnums.SIGNINPOLICY}`;
};

export const msalConfig = (authority) => {
  return {
    auth: {
      knownAuthorities: [configData.REACT_APP_B2C_TENANT_ID],
      // redirectUri: '/',
      redirectUri: `${window.location.origin}/`,
      // postLogoutRedirectUri: 'window.location.origin',
      // navigateToLoginRequestUrl: 'true',
      clientId: configData.REACT_APP_B2C_CLIENTID,
      authority,
      navigateToLoginRequestUrl: false,
      postLogoutRedirectUri: '/'
      // validateAuthority: false
    },
    cache: {
      cacheLocation: 'localStorage', // This configures where your cache will be stored
      storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
      allowMultipleTabs: true,
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Critical:
              appInsights.trackException({
                error: message,
                severityLevel: SeverityLevel.Critical
              });
              return;
            case LogLevel.Error:
              appInsights.trackException({
                error: message,
                severityLevel: SeverityLevel.Error
              });
              console.error(message);
              return;
            case LogLevel.Info:
              // console.info(message);
              return;
            case LogLevel.Verbose:
              appInsights.trackException({
                error: message,
                severityLevel: SeverityLevel.Verbose
              });
              console.debug(message);
              return;
            case LogLevel.Warning:
              appInsights.trackException({
                error: message,
                severityLevel: SeverityLevel.Warning
              });
              console.warn(message);
              return;
            default:
              console.log(message);
          }
        }
      }
    }
  };
};

export const onboardingMsalConfig = {
  auth: {
    knownAuthorities: [configData.REACT_APP_B2C_TENANT_ID],
    clientId: configData.TIFO_APP_CLIENT_ID,
    authority: `${configData.REACT_APP_B2C_AUTHORITY}/${generalEnums.ONBOARDINGPOLICY}`,
    redirectUri: `${window.location.origin}/onboardingInteraction`,
    postLogoutRedirectUri: `${window.location.origin}/`,
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true
  }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: [configData.REACT_APP_B2C_READ_SCOPE]
};

export const loginRequestJobs = {
  state: 'page_url=jobs',
  scopes: [configData.REACT_APP_B2C_READ_SCOPE]
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
};
